import { ROLE, ROLE_GROUP } from '@/enums/person';

export const PERSON_GROUPS: { [key in ROLE]: ROLE_GROUP } = {
	ACTOR: ROLE_GROUP.STARRED,
	VOICE: ROLE_GROUP.STARRED,
	CAMEO: ROLE_GROUP.STARRED,
	SPECIAL_GUEST: ROLE_GROUP.STARRED,
	AUTHOR: ROLE_GROUP.WRITTEN,
	WRITER: ROLE_GROUP.WRITTEN,
	CO_WRITER: ROLE_GROUP.WRITTEN,
	STORY: ROLE_GROUP.WRITTEN,
	MUSIC: ROLE_GROUP.WRITTEN,
	ORIGINAL_MUSIC_COMPOSER: ROLE_GROUP.WRITTEN,
	SCREENPLAY: ROLE_GROUP.WRITTEN,
	SONGS: ROLE_GROUP.WRITTEN,
	PRODUCER: ROLE_GROUP.PRODUCED,
	EXECUTIVE_PRODUCER: ROLE_GROUP.PRODUCED,
	PRODUZENT: ROLE_GROUP.PRODUCED,
	CO_PRODUCER: ROLE_GROUP.PRODUCED,
	CO_EXECUTIVE_PRODUCER: ROLE_GROUP.PRODUCED,
	EDITOR: ROLE_GROUP.PRODUCED,
	PRODUCTION_DESIGN: ROLE_GROUP.PRODUCED,
	DIRECTOR: ROLE_GROUP.DIRECTED,
	SPECIAL_GUEST_DIRECTOR: ROLE_GROUP.DIRECTED,
	ASSISTANT_DIRECTOR: ROLE_GROUP.DIRECTED,
	VISUAL_EFFECTS: ROLE_GROUP.DIRECTED,
};
